import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PropTypes from 'prop-types';
import React from 'react';
import {figureWrapper, figureCaption} from './image-slice.module.scss';

const ImageSlice = ( { slice } ) => {
    return (
        <figure className={figureWrapper}>
            <GatsbyImage
                image={getImage(slice.primary.image)} 
                style={{maxWidth: slice.primary.image.dimensions ? slice.primary.image.dimensions.width : 750 }}
                alt={slice.primary.image.alt || 'PaycheckCity'}
                title={slice.primary.image.alt || 'PaycheckCity'}
                aria-describedby={slice.primary.image_caption ? slice.id : ''} />
            {slice.primary.image_caption && (
                <figcaption id={slice.id} className={`text-muted ${figureCaption}`} style={{maxWidth: slice.primary.image.dimensions ? slice.primary.image.dimensions.width : 750 }}>
                    <span dangerouslySetInnerHTML={{ __html: slice.primary.image_caption.html }} />
                </figcaption>
            )}
        </figure>
    );
};

ImageSlice.propTypes = {
    slice: PropTypes.object.isRequired,
};

export default ImageSlice;
